export default "__VITE_ASSET__CWRKQG4q__"